var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('header-name',[_vm._v("\n        Timesheet for "+_vm._s(_vm.$page.props.timesheet.user.name)+" - month starting\n        "+_vm._s(_vm.momentFormatDateYear(_vm.$page.props.timesheet.start_date))+"\n    ")]),_vm._v(" "),_c('breadcrumbs',{attrs:{"items":_vm.breadItems}}),_vm._v(" "),_c('timesheet-show')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }